import { NavLink, Link } from "react-router-dom";
import { Award, Download, Mail, Star } from "lucide-react";

const linkBase =
  "font-mono text-sm uppercase tracking-[0.18em] px-3 py-2 rounded-sm transition-colors flex items-center gap-1.5";

function navCls({ isActive }) {
  return `${linkBase} ${
    isActive
      ? "text-[#5EA529] border-b-2 border-[#5EA529]"
      : "text-black/70 hover:text-black border-b-2 border-transparent"
  }`;
}

export default function PublicNav() {
  return (
    <header
      data-testid="public-nav"
      className="border-b border-zinc-400/60 bg-[#D6D3D1]/95 backdrop-blur sticky top-0 z-30"
    >
      <div className="max-w-5xl mx-auto px-5 py-3 flex items-center justify-between gap-4 flex-wrap">
        <Link
          to="/"
          className="flex items-center gap-2.5 shrink-0"
          data-testid="nav-home-logo"
        >
          <img src="/logo.png" alt="Radio Club Ochentero" className="h-10 w-auto" />
          <span className="font-mono font-bold tracking-tighter text-base sm:text-lg text-black">
            Radio Club Ochentero
          </span>
        </Link>

        <nav className="flex items-center gap-1 sm:gap-2 flex-wrap">
          <NavLink to="/" end className={navCls} data-testid="nav-diplomas-link">
            <Award className="h-4 w-4" /> Diplomas activos
          </NavLink>
          <NavLink to="/activadores" className={navCls} data-testid="nav-activadores-link">
            <Star className="h-4 w-4" /> Diplomas de activadores
          </NavLink>
          <NavLink to="/descarga" className={navCls} data-testid="nav-descarga-link">
            <Download className="h-4 w-4" /> Descarga tu diploma/QSL
          </NavLink>
          <NavLink to="/contacto" className={navCls} data-testid="nav-contacto-link">
            <Mail className="h-4 w-4" /> Contacto
          </NavLink>
        </nav>
      </div>
    </header>
  );
}
